document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.best-sellers__carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.best-sellers__track');
    var prevBtn = carousel.querySelector('.best-sellers__arrow--prev');
    var nextBtn = carousel.querySelector('.best-sellers__arrow--next');

    if (!track || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      var card = track.querySelector('.best-sellers__card');
      if (!card) return 200;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || 16, 10);
      return card.offsetWidth * 2 + gap * 2;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
});